import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRunShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"run-shortcut, slash, skills"} maskId="square-filled-radius-0-stroke-1-IconRunShortcut"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM15.1621 6.25172L9.74828 18.1621L8.83792 17.7483L14.2517 5.83792L15.1621 6.25172Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconRunShortcut;
